import React, { ChangeEvent } from "react";
import { TextField } from "@mui/material";
import { useTranslation } from "react-i18next";
import dayjs, { Dayjs } from "dayjs";
import { FizAgent, IpAgent } from "../../../types/agentTypes";
import {
  FieldColumn,
  FieldRow,
  Section,
  SectionTitle,
  StyledDatePicker,
} from "../styles";

type PassportAgentState = FizAgent | IpAgent;

type PassportSectionProps = {
  formData: PassportAgentState;
  setFormData: React.Dispatch<React.SetStateAction<any>>;
  onChange: (
    e: ChangeEvent<HTMLInputElement | HTMLTextAreaElement | HTMLSelectElement>,
  ) => void;
};

const PassportSection = ({
  formData,
  setFormData,
  onChange,
}: PassportSectionProps) => {
  const { t } = useTranslation();

  return (
    <Section>
      <SectionTitle>{t("createAgent.passport.title")}</SectionTitle>

      <FieldRow>
        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.passport.series")}
            name="doc_series"
            value={formData.doc_series ?? ""}
            fullWidth
            required
            onChange={onChange}
          />
        </FieldColumn>

        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.passport.number")}
            name="doc_number"
            value={formData.doc_number ?? ""}
            fullWidth
            required
            onChange={onChange}
          />
        </FieldColumn>
      </FieldRow>

      <FieldRow>
        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.passport.issuedBy")}
            name="document_issue"
            value={formData.document_issue ?? ""}
            fullWidth
            required
            onChange={onChange}
          />
        </FieldColumn>

        <FieldColumn>
          <StyledDatePicker
            value={
              formData.document_date_issue
                ? dayjs(formData.document_date_issue)
                : null
            }
            label={t("createAgent.passport.issueDate")}
            onChange={(date) => {
              const typedDate = date as Dayjs | null;

              setFormData((prev: any) => ({
                ...prev,
                document_date_issue: typedDate
                  ? typedDate.format("YYYY-MM-DD")
                  : "",
              }));
            }}
            format="DD-MM-YYYY"
          />
        </FieldColumn>

        <FieldColumn>
          <TextField
            size="small"
            label={t("createAgent.passport.departmentCode")}
            name="document_issue_code"
            value={formData.document_issue_code ?? ""}
            fullWidth
            onChange={onChange}
          />
        </FieldColumn>
      </FieldRow>
    </Section>
  );
};

export default PassportSection;
